import { postMockApplicantCreditCheckRequest } from '../../../../../../RentalPortalApplicant'
import { useApplicantProfileContext } from '../../../../RentalPortalApplicantProfile.hooks'
import { getApplicantCreditCheckGateMode } from '../../ApplicantCreditCheckBlock.utils'
import { ApplicantCreditCheckGateModal } from '../../ApplicantCreditCheckGateModal'

export function useApplicantCreditCheckRequest() {
  const {
    applicantData,
    applicantId,
    handleCloseModal,
    handleEntityReload,
    setModal,
  } = useApplicantProfileContext()

  async function submitRequest(mode) {
    await postMockApplicantCreditCheckRequest({
      applicantId,
      isConsentAcknowledged: true,
      mode,
    })

    handleCloseModal()

    await handleEntityReload()
  }

  function handleOpenGate(action) {
    const mode = getApplicantCreditCheckGateMode(action)

    setModal(
      <ApplicantCreditCheckGateModal
        creditCheck={applicantData?.credit_check}
        mode={mode}
        onClose={handleCloseModal}
        onSubmit={() => submitRequest(mode)}
      />
    )
  }

  return { handleOpenGate }
}
